import type { ReactNode } from 'react';

/**
 * 문장 단위 개행 (23-A회차, UI 피드백 13).
 *
 * 설명이 세 문장 넘게 한 줄로 이어지면 어디서 끊어 읽어야 할지 알 수 없다("…변환한다. 오늘
 * 폴더는…"). 구획 설명·빈 상태 안내는 **문장마다 줄을 나눈다**. 기준은 두 가지다.
 *   - 문장(마침표)마다 한 줄. 배열의 원소 하나가 한 줄이다
 *   - 짧은 두 문장(합쳐 40자 안쪽)은 한 줄에 둔다. 줄만 늘어나고 읽기는 나아지지 않는다
 *
 * 여는 쪽은 `note={['첫 문장.', '둘째 문장']}`처럼 배열을 준다. 문자열 하나면 그대로 둔다 —
 * 이미 한 줄인 설명까지 고칠 이유가 없다.
 *
 * 줄바꿈을 `<br />`가 아니라 블록 요소로 하는 이유는 문장이 화면 폭에 걸려 접힐 때
 * 다음 문장과 붙지 않게 하기 위해서다.
 */
export function Lines({ lines }: { lines: readonly ReactNode[] }) {
  return (
    <>
      {lines.map((line, at) => (
        <span key={keyOf(line, at)} className="block">
          {line}
        </span>
      ))}
    </>
  );
}

/**
 * 설명 하나. 배열이면 줄을 나누고, 아니면 받은 것을 그대로 돌려준다.
 * `note`·`hint`를 받는 부품이 전부 이것을 거친다
 */
export function asLines(note: ReactNode): ReactNode {
  return Array.isArray(note) ? <Lines lines={note} /> : note;
}

/** 문장 자체가 키다. 글이 겹치는 줄은 없다. 문장이 아닌 조각만 자리 번호를 쓴다 */
function keyOf(line: ReactNode, at: number): string {
  return typeof line === 'string' ? line : `줄 ${at}`;
}
